/**
 * One spelling for a vehicle side, so two records can be matched on it.
 *
 * The same side arrives written several ways depending on which collection it
 * came from: `front_right`, `frontRight`, `Front Right`, and `back_left`
 * against `rear_left`. The lightbox pairs a damage photograph with its
 * un-annotated ROI original by side, and an exact string comparison there
 * quietly fails — the toggle appears to do nothing, because the match returns
 * nothing and the code falls back to the image it already had.
 *
 * Separators are removed rather than normalised to one, because the variants
 * disagree about whether there is a separator at all. `back` is folded to
 * `rear` because both appear for the same side.
 */
export const normalizeSideKey = (side) =>
  (side || "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "")
    .replace(/^back/, "rear");

/** True when two side labels name the same side, however each is written. */
export const sameSide = (a, b) => {
  const left = normalizeSideKey(a);
  return left !== "" && left === normalizeSideKey(b);
};

export default normalizeSideKey;
